module.exports = __webpack_public_path__ + "img/68.ffa36978.jpg";